

export const formatTime = (time) => {
  if (!time || Number.isNaN(time)) return '0:00';
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export const toggleFullscreen = (containerRef, isFullscreen) => {
  if (!containerRef.current) return;
  
  if (isFullscreen) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  } else if (containerRef.current.requestFullscreen) {
    containerRef.current.requestFullscreen();
  } else if (containerRef.current.webkitRequestFullscreen) {
    containerRef.current.webkitRequestFullscreen();
  }
};

export const togglePictureInPicture = async (videoElement) => {
  try {
    if (!videoElement) return;
    if (document.pictureInPictureElement) {
      await document.exitPictureInPicture();
    } else if (videoElement.requestPictureInPicture) {
      await videoElement.requestPictureInPicture();
    }
  } catch (error) {
    console.error('PiP error:', error);
  }
};
